/* global femcare */
 
femcare.tracking.analyticsEvents = {
    init: function () {
        var analyticsCookie = this.getCookie('AnalyticsEvents');
 
        if (typeof dataLayer !== 'undefined' && analyticsCookie) {
            var analyticsEvents = JSON.parse(analyticsCookie);
 
            for (var index = 0; index < analyticsEvents.length; index++) {
                window.dataLayer.push(analyticsEvents[index]);
            }
 
            this.deleteCookie('AnalyticsEvents');
        }
 
        this.addClickToBuyIframeAnalyticsData();
    },
 
    deleteCookie: function (name) {
        document.cookie = name + '=;path=/;expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
 
    getCookie: function (name) {
        var value = '; ' + document.cookie;
        var parts = value.split('; ' + name + '=');
        if (parts.length === 2) {
            return parts
                .pop()
                .split(';')
                .shift();
        }
    },
    /**
     * Handles messages from an external click2buy iframe and push analytics data to the dataLayer.
     */
    addClickToBuyIframeAnalyticsData: function () {
        window.addEventListener('message', function (event) {
            if (event.origin !== 'https://widget.clic2buy.com') {
                return;
            }
 
            if (event.data && event.data.action === 'select_retail_outlet') {
 
                const productName = $('.product-main__name').text().trim();
                const ean = $('.product-main').data('ean');
 
                const retailer_ga4_data = {
                    retailer: event.data.retail_outlet.retailer_name,
                    single_item_id: ean,
                    single_item_name: productName
                };
 
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'ga4_buy_now_go_to_retailer',
                    ga4_data: retailer_ga4_data
                });
            }
        });
    }
};